import type { SVGProps } from 'react';

export const CheckIcon: React.FC<SVGProps<SVGSVGElement>> = ({ width = 18, height = 15, color = '#5DDF48', ...props }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 18 15"
      fill="none"
      color={color}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M1.93799 10.6443L4.86764 13.574L16.5862 1.85547"
        stroke={color}
        strokeWidth="2.32106"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};